import React, { useState, useEffect, useContext } from "react";
import { Card, Image, Steps, Progress, Badge, Button } from "antd";
import headerimg from "../../assets/images/Get started svg.svg";
import footerimg from "../../assets/images/Help.svg";
import coderepoimg from "../../assets/images/code repo.svg";
import finalstepimg from "../../assets/images/CICD.svg";
import agiler from "../../assets/images/OIP.jpg"
import createcategory from "../../createcategory";
import ProjectModules from "../KanbanBoard/project/ProjectModules";
import moment from "moment";
import { toast, Slide } from "react-toastify";
import {
  HANDLE_ON_CHANGE,
} from "../../redux/CommonInitialsate";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import ReactImageFallback from "react-image-fallback";
import Agilepmsvg from "../../assets/images/AgilePM.svg";
import Devopscicidsvg from "../../assets/images/DevOps CICD.svg";
import { Col, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import DateFnsUtils from "@date-io/date-fns";

import Select from "react-select";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import {  MenuItem, InputLabel, FormControl, TextField,FormHelperText } from "@material-ui/core";
import { Form, FormFeedback, Input } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import axios from "../../axios"
import UserContext from "../../index";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/dist/style.css";

const { Step } = Steps;

function Getstartedpage({setroadmap}) {
  let id =
    localStorage.getItem("clientid") == "undefined"
      ? ""
      : JSON.parse(localStorage.getItem("clientid"));
      let rolecode =
      localStorage.getItem("Rolecode") == "undefined"
        ? ""
        : JSON.parse(localStorage.getItem("Rolecode"));
    let userdetails =
      localStorage.getItem("clientdetails") == "undefined"
        ? ""
        : JSON.parse(localStorage.getItem("clientdetails"));
      
    let createdby =
      localStorage.getItem("Empdetails") == "undefined"
        ? ""
        : JSON.parse(localStorage.getItem("Empdetails"));
    let projects =
      localStorage.getItem("Orgsubscriptiondetails") == "undefined"
        ? ""
        : JSON.parse(localStorage.getItem("Orgsubscriptiondetails"));
  
    let empid =
      localStorage.getItem("Empdetails") == "undefined"
        ? ""
        : JSON.parse(localStorage.getItem("Empdetails"));
    let projectslength = projects?.map((e) => e.PlanCap?.Projects);
    let orgplancap =
    localStorage.getItem("Orgsubscriptiondetails") == "undefined"
      ? ""
      : JSON.parse(localStorage.getItem("Orgsubscriptiondetails"));
  let empdetails = JSON.parse(localStorage.getItem("Empdetails"));
  let userlimit =
    orgplancap == null ? "" : orgplancap.map((e) => e.PlanCap.Users);
    const username = localStorage.getItem("username") == undefined ? "" : JSON.parse(localStorage.getItem("username"))
  
    const email = localStorage.getItem("email") == undefined ? "" : JSON.parse(localStorage.getItem("email"));
  const history = useHistory();
  const newDate = new Date();
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedProject, setSelectedProject] = useState("");
  const [checkSubmit, setSubmitCheck] = useState(false);
  const [projectnames, setProjectNames] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedDate2, setSelectedDate2] = useState(
    newDate.setMonth(newDate.getMonth() + 6)
  );
  const [modules, setModules] = useState([
    {
      Name: "",
      Type: "Monolith",
      FullName: "",
    },
  ]);
  const [error, setError] = useState({});
  const [dateerror, setdateerror] = useState("");
  const [projectOptions, setProjectOptions] = useState([]);
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [number, setNumber] = useState("");
  const [Teamdetails, setTeamdetails] = useState([]);
  const contextval = useContext(UserContext);
  const dispatch = useDispatch();

  // State for inviting team members
  const [firstname, setfirstname] = useState("");
  const [secondname, setsecondname] = useState("");
  const [Email, setEmail] = useState([]);
  const [phone, setphone] = useState("");
  const [errors, setErrors] = useState({});
  const [checkSubmitteam, setSubmitCheckteam] = useState(false);

  // State for project allocation
  // Project Allocation Variables
  const [employee2,setEmployee2] = useState([]);
  const [Projroledata, setProjroledata] = useState([]);
  const [managers, setManagers] = useState(null);
  const [Refesh, setRefesh] = useState(true);
  const intialValue = {
    TeamMemberId: [],
    ProjectCode: 0,
    ProjectStartDate: new Date(),
    ProjectEndDate: new Date(newDate.setMonth(newDate.getMonth() + 6)),
    ManagerId: createdby[0]?.ClientUserId,
    AllocPercentage: "100",
    ProjectRole: {
      RoleGroupId: "",
      RoleCode: 0,
      RoleName: "",
    },
    MappedBy: createdby[0]?.ClientUserId,
    MappedByDetails: {
      ContactName: username,
      ContactDesignation: userdetails[0]?.RoleDetails?.RoleCode,
      ContactEmail: userdetails[0]?.UserDetails?.Email,
      ContactPhone: userdetails[0]?.OrgDetails?.ContactPhone,
    },
    IsCurrent: "Y",
    Status: null,
    ClientId: id,
  };
  const [Values, setValues] = useState(
    intialValue
  );
  const [Errors, setErrorsa] = useState({});

  const handleNext = () => {
    setCurrentStep((prevStep) => (prevStep < 4 ? prevStep + 1 : prevStep));
  };

  const handlePrev = () => {
    setCurrentStep((prevStep) => (prevStep > 1 ? prevStep - 1 : prevStep));
  };
  const close = () =>{
    setroadmap(false)
  }
  const {  projectdetails ,dateformat,projectRole} = useSelector((state) => state.user);
  useEffect(() => {
    // Fetch project options and other data
    if (id) {
      axios
        .get(`agilesaas_project_master?ClientId=eq.` + id)
        .then((res) => {
          setProjectOptions(res.data);
          dispatch({
            type: "HANDLE_ON_CHANGE",
            payload: {
              name: "projectdetails",
              value: res.data.map((e) => ({ ...e, selectOption: false })),
            },
          });
        })
        .catch((error) => console.error("Error fetching projects:", error));
    }
    axios
    .get("agilesaas_roles_master")
    .then((res) => setManagers(res.data))
    .catch((err) => console.log(err));
    axios
    .get(
      "subscription_user_role_mapping?ProductDetails->>ProdId=eq.11004&ClientId=eq." +
      id +
      "&LoginEnabled=eq.Y"
    )
    .then((res) => {
      let getdata = res.data;
      let filteredData = [];
      axios
        .get("subscription_client_users?ClientId=eq." + id + "&IsActive=eq.Y")
        .then((re) => {
          let userdata = re.data;
          getdata.map((e) => {
            let check = userdata.filter((x) => x.ClientUserId == e.UserId);
            if (check.length != 0) {
              filteredData.push(e);
            }
          });
        });
      setEmployee2(filteredData);
    })
    .catch((err) => {
      console.log(err);
      axios.get(`subscription_client_users?ClientId=eq.` + id).then((res) => {
        let a = res.data?.find(
          (e) => e?.OfficialEmail == email?.login
        )?.ClientUserId;
  
  
          // setTeamdetails(c)
          // const check = res.data?.map((f)=>f.TeamMemberId === c  && f.iscurrent != "N")?.map((k)=>k.projectname+" "+k.allocpercentage );
          // let project =
          
          setTeamdetails(
            res.data.map((e) => {
              return { ...e, selectOption: false };
            })
          );
      
      });
    });
  }, []);


  const handleSelectProject = (e) => {
    
    const newDate = new Date();
    setModules(
      e?.data?.ProjectModules
        ? e?.data?.ProjectModules
        : [
            {
              Name:
                e?.data &&
                e?.data?.ProjectName?.replace(/\s+/g, "")?.replace(
                  /[^a-zA-Z0-9]/g,
                  ""
                ),
              Type: "Monolith",
              FullName: "",
            },
          ]
    );
    handleDateChange(e?.data ? new Date(e?.data?.StartDate) : new Date());
    handleDateChange2(
      e?.data
        ? new Date(e?.data?.EndDate)
        : newDate.setMonth(newDate.getMonth() + 6)
    );
    setSelectedProject(e);
    setProjectNames(e?.data?.ProjectName ? e?.data?.ProjectName : "");
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const DateInputChange = (e, vaildateOnChange = false) => {
    setValues({
      ...Values,
      [e.target.name]: moment(e.target.value).format("YYYY-MM-DD"),
    });
  };
  const convertToPara = (name, value) => ({
    target: {
      name,
      value,
    },
  });
  const handleDateChange2 = (date) => {
    setSelectedDate2(date);
  };

  let managerdropdown = managers?.filter(
    (e) => e.RoleCode != "BO" && e.RoleCode != "PO"
  );
  const roleOption =
  managerdropdown?.length == 0
    ? []
    : managerdropdown?.map((man) => {
      return {
        value: man.RoleGroupId,
        label: man.RoleName,
        RoleCode: man.RoleCode,
      };
    });
  const employeeOption =
  employee2?.length == 0
    ? []
    : employee2
      // ?.filter(
      //   (e) =>
      //     e.RoleDetails.RoleCode != "SM" && e.RoleDetails.RoleCode != "KA"
      // )
      ?.map((emp) => {
        return {
          value: emp.UserId,
          label: emp.UserDetails.Firstname + " " + emp.UserDetails.Lastname,
          pertec: Projroledata.filter(
            (ge) => ge.TeamMemberId === emp.UserId
          )
            .map((e) => parseInt(e.AllocPercentage, 10))
            .reduce((acc, val) => acc + val, 0),
        };
      });
      const projectOptioeen =
      projectOptions?.length == 0
        ? []
        : projectOptions?.map((pro) => {
          return {
            value: pro.ProjectId,
            label: pro.ProjectName,
          };
        });
const handleInputChange = (e, name) => {
    if (name === "TeamMemberId") {
      let value = Array.isArray(e)
        ? e.map((x) => x.value)
        : [];
      setValues({ ...Values, [name]: value });
    } else if (name === "AllocPercentage") {
      setValues({ ...Values, [name]: e.target.value });
    } else {
      setValues({ ...Values, [name]: e.value });
    }
  };
  const handleProjectNameChange = (e) => {
    let text = e.target.value;

    setProjectNames(text);
    const updatedModules = modules.map((module) => ({
      ...module,
      Name: e.target.value.replace(/\s+/g, "").replace(/[^a-zA-Z0-9]/g, ""),
    }));
    setModules(updatedModules);
  };
  const poptions = [
    { label: "New Project", value: "new", data: "" },
    ...(projectOptions?.length > 0
      ? projectOptions.map((x) => ({
          label: x?.ProjectName,
          value: x?.ProjectId,
          data: x,
        }))
      : []),
  ];
  

  const selectedValue = selectedProject ? selectedProject.value : "new";

  const validateForm = () => {
    // let gmailEmails = Email.some((email) => email.includes(`@${orgmail}`));
    // let gmailEmails = Email?.some((email) => email?.includes(`@${orgmail?.split(`.`)?.[0]}`))
    // console.log(Email, "length", Email.length, "ll",gmailEmails,"validation check");
    const newErrors = {};
    // if (firstname.trim() == "") {
    //   newErrors.firstname = "Enter the first name";
    // } else if (secondname.trim() == "") {
    //   newErrors.secondname = "Enter the Last name";
    // } else
    if (Email.length == 0) {
      newErrors.email = "Email is required";
    } else if (Email.length == 11) {
      alert("Maximum 10 numbers can allow");
    }
    //  else if (!gmailEmails) {
    //   newErrors.email = "Enter your organization Mail-id";
    // } 
    else if (!/\S+@\S+\.\S+/.test(Email)) {
      newErrors.email = "Email is invalid";
    } else if (Teamdetails?.find((e) => e.OfficialEmail === Email)) {
     
        newErrors.email = "Already existing Mail Id";
      
    }
    //  else if (phone === "") {
    //   newErrors.phone = "Enter the phone number";
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };
  
  const sendInvitationEmail = async (emailData) => {
    try {
      const emailResponse = await axios.post("/api/agile/email", emailData);
      console.log(emailResponse.data, "Email sent");
    } catch (emailError) {
      console.error("Error sending email:", emailError);
    }
  };

  const createUserAndSendEmail = async () => {
    for (let i = 0; i < Email.length; i++) {
      let postsubscription = {
        orgadmin: true,
        CurrentPlanId: 11006,
        User_Details: {
          ClientId: id,
          ClientDetails: {
            Company: userorg?.Company,
            ContactName: userorg?.ContactName,
            ContactDesignation: userorg?.ContactDesignation,
            ContactEmail: userorg?.ContactEmail,
            ContactPhone: userorg?.ContactPhone,
          },
          ApprovedDate:
            empdetails?.[0]?.IsOrgAdmin == "Y"
              ? moment().format("YYYY-MM-DD HH:mm:ss")
              : null,
          OnboardedDate: moment().format("YYYY-MM-DD HH:mm:ss"),
          OnboardedByDetails: {
            OnboardedName:
              empdetails?.[0]?.UserFirstname +
              " " +
              empdetails?.[0]?.UserLastname,
          },
          OnboardedBy: empdetails?.[0]?.ClientUserId,
          ApprovedByDetails:
            empdetails?.[0]?.IsOrgAdmin == "Y"
              ? // {
                //   "AdminId": id,
                //   "AdminEmail": empdetails?.[0]?.OfficialEmail,
                // }
                null
              : null,
          IsApproved: empdetails?.[0]?.IsOrgAdmin == "Y" ? "Y" : null,
          DepartmentDetails: "Common",
          UserFirstname: firstname == "" ? "FN" : firstname,
          UserLastname: secondname == "" ? "LN" : secondname,
          OfficialEmail: Email[i].toLowerCase(),
          IsEmailVerified: "Y",
          Phone: phone == "" ? userorg?.ContactPhone?.replace(/\s+/g, '') : phone?.replace(/\s+/g, ''),
          DateCreated: moment().format("YYYY-MM-DD HH:MM:ss"),
          IsOrgAdmin: "N",
          IsActive: null,
        },
        User_Role: [
          {
            ClientId: id,
            UserDetails: {
              Firstname: firstname == "" ? "FN" : firstname,
              Lastname: secondname == "" ? "LN" : secondname,
              Email: Email[i],
            },
            RoleDetails: {
              RoleCode: "KU",
              RoleName: "Kanban User",
            },
            ProductDetails: {
              ProdId: "11004",
              ProdName: "KANBAN",
              Domain: "kanban.yozytech.com",
            },
            LoginEnabled: "Y",
            OrgDetails: {
              Company: userorg?.Company,
              ContactName: userorg?.ContactName,
              ContactDesignation: userorg?.ContactDesignation,
              ContactEmail: userorg?.ContactEmail,
              ContactPhone: userorg?.ContactPhone,
            },
          },
        ],
      };


      try {
        const subscriptionResponse = await axios.post(
          "/api/v1/subscription/usercreation",
          postsubscription
        );

        if (subscriptionResponse.status === 201) {
          let emaildata = {
            ClientUserId: empdetails?.[0]?.ClientUserId,
            ClientId: id,
            ClientDetails: {
              Company: userorg?.Company,
              ContactName: userorg?.ContactName,
              ContactDesignation: userorg?.ContactDesignation,
              ContactEmail: userorg?.ContactEmail,
              ContactPhone: userorg?.ContactPhone,
            },
            DepartmentDetails: empdetails?.[0]?.DepartmentDetails,
            DepartmentCode: "",
            TentantId: "",
            FromSenderId: "no-reply@yozytech.com",
            ToEmailIds: {
              emailids: Email[i].toLowerCase(),
            },
            CcEmailIds: {
              emailids: ["agileteam@yozytech.com","support@yozytech.com"],
            },
            BccEmailIds: "",
            EmailType: "UserInvitation",
            ProductDetails: {
              ProdId: "11000",
              ProdName: "Subscription",
              Domain: "Subscription.yozytech.com",
            },
            EmailSubject: "User invite notification",
            IsSuccess: "",
            IsPartiallyFailed: " ",
            SendRetryHistory: "",
            IsActive: " ",
            Status: "",
            emailnotify: true,
            webnotify: false,
            EmailTemplateName: "UserInvitation",
            EmailTemplateVariables: {
              xxasignbyxx: "",
              xxassigndatexx: "",
              xxprjdisxx: Email[i],
              xxprjnamexx:
                firstname == "" && secondname == ""
                  ? "User"
                  : firstname + " " + secondname,
              xxstoryNamexx: "",
              xxprjpercenxx: "",
              xxprjstartdatexx: firstname == "" ? "0" : firstname,
              xxprjenddataexx: secondname == "" ? "0" : secondname,
              xxteamnamexx:
                empdetails?.[0]?.UserFirstname +
                " " +
                empdetails?.[0]?.UserLastname,
              xxsprintxx: "",
              xxmanagernamexx: userorg?.ContactName,
              xxcompanyname: userorg?.Company,
              xxmanagerdesigxx: "Scrum Master",
              xxgmailxx: userorg?.ContactEmail,
              xxphnoxx: userorg?.ContactPhone,
            },
          };
          // if (another == true) {
          //   toast.success(
          //     empdetails?.[0]?.IsOrgAdmin == "Y"
          //       ? `User Created SuccessFully`
          //       : `User Created SuccessFully Wait For the Approval from Admin`,
          //     {
          //       position: toast.TOP_RIGHT,
          //       autoClose: 3000,
          //       draggable: true,
          //     }
          //   );
          //   // setopenProCreate(false);
         
          // } else {
            toast.success(
              empdetails?.[0]?.IsOrgAdmin == "Y"
                ? `User Created SuccessFully`
                : `User Created SuccessFully Wait For the Approval from Admin`,
              {
                position: toast.TOP_RIGHT,
                autoClose: 3000,
                draggable: true,
              }
            );

        
          // }

          await sendInvitationEmail(emaildata);
        }

     
        teamclose()
      } catch (subscriptionError) {
        console.error("Error creating user:", subscriptionError);
      }
    }

    // Additional code after the loop if needed
    setSubmitCheckteam(false);
  };
  const submitTeamMember = (e) => {
    e.preventDefault();
    if (userlimit <= Teamdetails.length) {
      toast.error(
        `Team creation limit reached. Please upgrade to higher plan for Proceed Furthur...`,
        {
          transition: Slide,
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 4000,
          draggable: true,
        }
      );
      
    } else if (Email.length != 1 && firstname != "" && secondname != "") {
      alert("For Bulk User creation remove Firstname and Lastname");
    } else {
      if (validateForm()) {
        // setSubmitCheck(true);
        createUserAndSendEmail();
      
      }
    }
  };
  const projectname = projectOptions
  ?.filter((e) => e.ProjectId === Values.ProjectCode)
  ?.map((f) => f.ProjectName);
  const resetForm = () => {
    setValues(intialValue);
    setErrorsa({});
  };
  function calculateRemainingAllocation(currentAllocation, newAllocation) {
    // Ensure currentAllocation is a number between 0 and 100
    currentAllocation = Math.min(
      Math.max(parseFloat(currentAllocation) || 0, 0),
      100
    );

    // Ensure newAllocation is a number between 0 and 100
    newAllocation = Math.min(Math.max(parseFloat(newAllocation) || 0, 0), 100);

    // Calculate remaining allocation
    let remainingAllocation = 100 - currentAllocation;

    // If newAllocation is greater than remainingAllocation, set it to remainingAllocation
    let allocatedPercentage = Math.min(newAllocation, remainingAllocation);

    return allocatedPercentage;
  }
  const addAllocationHandler = (e) => {
    e.preventDefault();
  
    let temp = { ...Errors };
    temp.ProjectStartDate =
      moment(Values.ProjectStartDate) >= moment(Values.ProjectEndDate) === false
        ? ""
        : "StartDate should be lower than EndDate";
    temp.ProjectCode =
      Values.ProjectCode === 0 ? "Please select a Project" : "";
    temp.ProjectRole =
      Values.ProjectRole.RoleCode === 0 ? "Please select a Role" : "";
    temp.AllocPercentage =
      Values.AllocPercentage < 0 || Values.AllocPercentage > 100
        ? "Percentage must be between 0 to 100"
        : Values.AllocPercentage == "" || Values.AllocPercentage.length == 0
        ? "Please enter percentage"
        : "";
    temp.TeamMemberId = "";
  
    if (Values.TeamMemberId.length > 0) {
      const PostArray = Values.TeamMemberId?.map((e) => {
        let sample = { ...Values };
        sample.TeamMemberId = e;
        let remainingAllocation = calculateRemainingAllocation(
          parseInt(employeeOption.filter((g) => g.value === e)[0]?.pertec),
          parseInt(Values.AllocPercentage)
        );
        sample.AllocPercentage = remainingAllocation;
        temp.TeamMemberId =
          Values.TeamMemberId.length === 0
            ? "Please select team member id"
            : parseInt(
                employeeOption.filter((g) => g.value === e)[0]?.pertec
              ) === 100
            ? "Already 100% allocated"
            : "";
        return sample;
      });
  
      setErrorsa({ ...temp });
  
      function removeDuplicateProjects(Projroledata, Postdata) {
        const uniqueProjects = new Set(
          Projroledata.map(
            (item) => `${item.TeamMemberId}_${item.ProjectCode}`
          )
        );
        const filteredPostdata = Postdata.filter(
          (item) =>
            !uniqueProjects.has(`${item.TeamMemberId}_${item.ProjectCode}`)
        );
  
        return filteredPostdata;
      }
  
      let filteredPostdata = removeDuplicateProjects(Projroledata, PostArray);
  
      if (filteredPostdata.length === Values.TeamMemberId.length) {
        if (
          Values.ProjectCode === 0 ||
          Values.ProjectRole.RoleCode === 0 ||
          Values.AllocPercentage == "" ||
          Values.AllocPercentage.length == 0
        ) {
          setErrorsa({ ...temp });
        } else if (
          temp.AllocPercentage != "" ||
          temp.TeamMemberId !== "" ||
          temp.ProjectCode !== "" ||
          temp.ProjectRole !== "" ||
          temp.ProjectStartDate !== ""
        ) {
          setErrorsa({ ...temp });
        } else {
          const nonNullResultArray = employee2.map((e) => {
            const filteredData = filteredPostdata.filter(
              (f) => f.TeamMemberId === e.UserId && f.AllocPercentage > 0
            );
            return filteredData.length > 0 ? e.UserDetails.Email : null;
          });
          const ToEmail = nonNullResultArray.filter(
            (email) => email !== null
          );
          ToEmail?.map((Toemails) => {
            let requrireddata = {
              ClientUserId: createdby?.[0]?.ClientUserId,
              ClientId: id,
              // Other email fields
              ToEmailIds: { emailids: Toemails },
              CcEmailIds: {
                emailids: ['agileteam@yozytech.com', 'support@yozytech.com'],
              },
              EmailSubject: "Project Allocation Notification",
              EmailTemplateVariables: {
                xxprjnamexx: projectname[0],
                xxprjpercenxx: Values.AllocPercentage,
                xxprjstartdatexx: moment(Values.ProjectStartDate).format(
                  dateformat
                ),
                xxprjenddataexx: moment(Values.ProjectEndDate).format(
                  dateformat
                ),
              },
            };
            axios({
              url: `${process.env.REACT_APP_API_BASE_URL}/api/agile/email`,
              method: "post",
              data: requrireddata,
              headers: {
                origin: process.env.REACT_APP_KANBAN_ORIGIN,
                "Content-Type": "application/json",
              },
            })
              .then((res) => console.log(res.data))
              .catch((err) => console.log(err));
          });
  
          setSubmitCheck(true);
          axios
            .post(
              "agilesaas_project_mapping",
              filteredPostdata.filter((e) => e.AllocPercentage > 0)
            )
            .then((res) => {
              setSubmitCheck(false);
              toast.success(`Project Allocated`, {
                transition: Slide,
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000,
                draggable: true,
              });
              setValues(intialValue);
              setRefesh(true);
              resetForm();
              setErrorsa({});
            });
        }
      } else {
        temp.TeamMemberId =
          Values.TeamMemberId?.length === 1
            ? " Already allocated in same project "
            : "Someone had already allocated in same project ";
        setErrorsa({ ...temp });
      }
    } else {
      temp.TeamMemberId = "Please select a team member";
      setErrorsa({ ...temp });
    }
  
    setRefesh(true);
    // loadData(Values.TeamMemberId);
  };
  
  

  const userorg = userdetails[0]?.OrgDetails;
  const userdet = userdetails[0]?.UserDetails;
  const check = projectOptions?.map((e) => e.ProjectId).length;
  console.log(check,"ckllk");
  
  const handleProjectSubmit = (e) => {

     
      axios.get(`agilesaas_project_master?ClientId=eq.` + id).then((res) => {
        const pdname = res?.data?.map((x) =>
          x.ProjectName?.replace(/\s+/g, "")?.replace(/[^a-zA-Z0-9]/g, "")
        );
      
        let prjcode = res.data
          ?.filter((e) => e.ProjectId)
          .sort()
          .slice(-1);
        let code = prjcode[0]?.ProjectShortCode;
  
        const numericPart = parseInt(code?.slice(4), 10) + 1;
  
        
        const nextNumericPart = String(numericPart).padStart(6, "0");
  
     
  
        setNumber(`${projectnames?.slice(0, 4)}${nextNumericPart}`);
  
  
        const chectknm =
          res.data.length != 0
            ? `${projectnames?.slice(0, 4)}${nextNumericPart}`
            : `${projectnames.slice(0, 4)}${"000001"}`;
  
      
  
        e.preventDefault();
        let postdata = {
          ProjectShortCode: chectknm,
          ProjectName: projectnames,
          ClientId: id,
          ClientDetails: {
            Company: userorg?.Company,
            ContactName: userorg?.ContactName,
            ContactDesignation: userorg?.ContactDesignation,
            ContactEmail: userorg?.ContactEmail,
            ContactPhone: userorg?.ContactPhone,
          },
          CreatedDate: moment().format("YYYY-MM-DD"),
          CreatedBy: empid[0]?.ClientUserId,
          CreatedByDetails: {
            Name:username,
            Role: rolecode,
            Email: userdet?.Email,
            Phone: userorg?.ContactPhone,
          },
          StartDate: moment(selectedDate).format("YYYY-MM-DD"),
          EndDate: moment(selectedDate2).format("YYYY-MM-DD"),
          IsActive: "Y",
          Status: null,
          ProjectModules: modules,
        };
        // console.log(postdata, "postdata")
        if (projectslength <= check) {
          toast.error(
            `You have exceeded the minimal plan please upgrade to higher plan Further... `,
            {
              transition: Slide,
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 8000,
              draggable: true,
            }
          );
        } else if (!modules.every((module) => module.Name && module.Type)) {
          toast.error(`Please enter all the module details `, {
            transition: Slide,
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
            draggable: true,
          });
        } else {
          // console.log(postdata)
          if (validateFormprojectc()) {
            if (
              modules.length > 0 &&
              [...new Set(modules?.map((item) => item.FullName))]?.length !=
                modules?.length
            ) {
              toast.error(
                `Please provide each module's full name as a unique name. `,
                {
                  transition: Slide,
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 8000,
                  draggable: true,
                }
              );
            } else if (pdname.includes(projectnames)) {
              toast.error(`Project is already created for this name. `, {
                transition: Slide,
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 8000,
                draggable: true,
              });
            } else {
              setSubmitCheck(true);
              if (selectedProject?.value == "new") {
                alert("hi")
                axios
                  .post(`agilesaas_project_master`, postdata)
  
                  .then((response) => {
                    //add category in a api while create a project
                    createcategory(projectnames);
                    setSubmitCheck(false);
                    axios
                      .get(`agilesaas_project_master?ClientId=eq.` + id)
                      .then((res) => {
                        // Initialize variables to store the most recent project's details
                        let latestProjects = [];
                        let latestCreatedDate = ""; // Initialize as an empty string
  
                        // Loop through the projects
                        for (const project of res.data) {
                          // Compare the current project's creation date to the latest created date
                          if (project.CreatedDate > latestCreatedDate) {
                            // If this project has a later creation date, reset the latest projects array
                            latestProjects = [project];
                            latestCreatedDate = project.CreatedDate;
                          } else if (project.CreatedDate === latestCreatedDate) {
                            // If this project has the same creation date as the latest, add it to the array
                            latestProjects.push(project.ProjectId);
                          }
                        }
  
                        // Find the project with the latest "ProjectId" among the latest projects
                        let lastUpdatedProject = latestProjects?.reduce(
                          (prev, current) => {
                            return prev.ProjectId > current.ProjectId
                              ? prev
                              : current;
                          }
                        );
                        let coeprj = lastUpdatedProject?.ProjectId;
                        const newDate = new Date();
                        let initialValue = {
                          TeamMemberId: empid[0]?.ClientUserId,
                          ProjectCode:
                            coeprj == undefined ? lastUpdatedProject : coeprj,
                          ProjectStartDate: new Date(selectedDate),
                          ProjectEndDate: new Date(selectedDate2),
                          ManagerId: createdby[0]?.ClientUserId,
                          AllocPercentage: 100,
                          ProjectRole: {
                            RoleGroupId: "1",
                            RoleCode: "SM",
                            RoleName: "Scrum Master",
                          },
                          MappedBy: createdby[0]?.ClientUserId,
                          MappedByDetails: {
                            ContactName: username,
                            ContactDesignation:
                              userdetails[0]?.RoleDetails?.RoleCode,
                            ContactEmail: userdetails[0]?.UserDetails?.Email,
                            ContactPhone:
                              userdetails[0]?.OrgDetails?.ContactPhone,
                          },
                          IsCurrent: "Y",
                          Status: null,
                          ClientId: id,
                        };
                        axios
                          .post("agilesaas_project_mapping", initialValue)
                          .then((res) => {
                            toast.success(
                              `🎉 The project has been successfully created! 🎉`,
                              {
                                transition: Slide,
                                position: toast.POSITION.TOP_RIGHT,
                                autoClose: 3000,
                                draggable: true,
                              }
                            );
                            let requrireddata = {
                              ClientUserId: createdby?.[0]?.ClientUserId,
                              ClientId: id,
                              ClientDetails: {
                                Company: userorg?.Company,
                                ContactName: userorg?.ContactName,
                                ContactDesignation: userorg?.ContactDesignation,
                                ContactEmail: userorg?.ContactEmail,
                                ContactPhone: userorg?.ContactPhone,
                              },
                              DepartmentDetails: createdby?.[0]?.DepartmentDetails,
                              DepartmentCode: null,
                              TentantId: "",
                              FromSenderId: "no-reply@yozytech.com",
                              ToEmailIds: {
                                emailids: email,
                              },
                              CcEmailIds: {
                                emailids: ['agileteam@yozytech.com','support@yozytech.com'],
                              },
                              BccEmailIds: "",
                              EmailType: "Project Created",
                              ProductDetails: {
                                ProdId: "11004",
                                ProdName: "KANBAN",
                                Domain: "KANBAN.yozytech.com",
                              },
                              EmailSubject: "Project Created Notification",
                              IsSuccess: "Y",
                              IsPartiallyFailed: " ",
                              SendRetryHistory: "",
                              IsActive: " ",
                              Status: "",
                              EmailTemplateName: "Projectcreation",
                              emailnotify: true,
                              webnotify: true,
                              EmailTemplateVariables: {
                                xxasignbyxx: "",
                                xxassigndatexx: "",
                                xxnotifytimexx: moment().format("YYYY-MM-DDTHH:mm:ss"),
                                xxprjdisxx: "",
                                xxprjnamexx: projectnames,
                                xxstoryNamexx: "",
                                xxprjpercenxx: "",
                                xxprjstartdatexx:  moment(selectedDate).format("YYYY-MM-DD"),
                                xxprjenddataexx: moment(selectedDate2).format("YYYY-MM-DD"),
                                xxteamnamexx: "",
                                xxsprintxx: "",
                                xxmanagernamexx: username,
                                xxcompanyname: userorg?.Company,
                                xxmanagerdesigxx: username,
                                xxgmailxx: userorg?.ContactEmail,
                                xxphnoxx: userorg?.ContactPhone,
                                webappdescri:`${projectnames} Projectcreated by ${username} `
                              },
                            };
                            console.log(requrireddata, "nandri to email");
                            axios({
                              url: `${process.env.REACT_APP_API_BASE_URL}/api/agile/email`,
                              method: "post",
                              data: requrireddata,
                              headers: {
                                origin: process.env.REACT_APP_KANBAN_ORIGIN,
                                "Content-Type": "application/json",
                              },
                            })
                              .then((res) => {
                                console.log(res.data, "success");
                              })
                              .catch((err) => {
                                console.log(err, "fail");
                              });                        });
                      });
                    Refresh();
                    setError({});
                    // setopenProCreate(false);
                ProjectClose()
                    // handleClose();
                  })
                  .catch((err) => {
                    // console.log(err)
                    setSubmitCheck(false);
                  });
  
             
           
              } else {
                let patchdata = {
                  // ProjectName: projectnames,
                  StartDate: moment(selectedDate).format("YYYY-MM-DD"),
                  EndDate: moment(selectedDate2).format("YYYY-MM-DD"),
                  ProjectModules: modules,
                };
                axios
                  .patch(
                    `agilesaas_project_master?ProjectId=eq.${selectedProject?.data?.ProjectId}`,
                    patchdata
                  )
                  .then((res) => {
                    Refresh();
                    setError({});
                    setSubmitCheck(false);
                    toast.success(`Project edited successfully`, {
                      position: toast.TOP_RIGHT,
                      autoClose: 3000,
                      draggable: true,
                    });
                  })
                  .catch((e) => {
                    setSubmitCheck(false);
                  });
              }
            }
          }
        }
      });
    
  };
  const cardContents = [
    {
      title: "Agile PM Roadmap",
      description: "Agile PM Step by Step",
      image: (
        <ReactImageFallback
          src={Agilepmsvg}
          initialImage="loader.gif"
          alt="Agile PM"
          style={{ width: "500px" }}
        />
      ),
      alt: "Agile PM Step by Step",
    },
    {
      title: "Devops CICD Roadmap",
      description: "Devops CICD Step by Step",
      image: (
        <ReactImageFallback
          src={Devopscicidsvg}
          initialImage="loader.gif"
          alt="DevOps CI/CD"
          style={{
            width: "500px",
          }}
        />
      ),
      alt: "Devops CICD Step by Step",
    },
  ];
  const handleNext1 = (e) => {
    e.stopPropagation();
    setCurrentCardIndex((prevIndex) => (prevIndex + 1) % cardContents.length);
  };

  const handleBack = (e) => {
    e.stopPropagation();
    setCurrentCardIndex(
      (prevIndex) => (prevIndex - 1 + cardContents.length) % cardContents.length
    );
  };

  const { title, description, image, alt } = cardContents[currentCardIndex];

  const instruction = (
    <div style={{ fontFamily: "DM Sans" }}>
      <Card>
        <CardActions style={{ padding: "9px 18px" }}>
          {/* <Row className="w-100 d-flex"> */}
          <Col md={9}>
            {/* <Typography gutterBottom variant="h6" component="h2">
                {title}
              </Typography> */}
          </Col>
          <Col md={3} className="d-flex justify-content-end">
            <button
              className="mr-2 rounded p-1 mt-1"
              style={{
                backgroundColor: "white",
                border: "1px solid lightblue",
                color: "black",
                fontSize: "12px",
                height: "30px",
                width: "50px",
              }}
              onClick={handleBack}
            >
              Back
            </button>
            <button
              className="rounded p-1 mt-1"
              style={{
                backgroundColor: "#00A9FF",
                color: "white",
                border: "none",
                fontSize: "12px",
                height: "30px",
                width: "50px",
              }}
              onClick={handleNext}
            >
              Next
            </button>
          </Col>
          {/* </Row> */}
        </CardActions>
        <CardContent style={{ padding: "9px 18px" }}>
          <div>{image}</div>
        </CardContent>
      </Card>
    </div>
  );
  function ProjectClose() {
    setSelectedProject({ label: "New Project", value: "new", data: "" });
   
    const newDate = new Date();
    // setopenProCreate(false);
    setProjectNames("");
    setError({});
    handleDateChange(new Date());
    handleDateChange2(newDate.setMonth(newDate.getMonth() + 6));
    setdateerror("");
    setModules([
      {
        Name: "",
        Type: "Monolith",
        FullName: "",
      },
    ]);
  }
  function teamclose(){
    setfirstname("");
    setsecondname("");
    setEmail([""]);
    setphone("");
   
  }
  function Refresh() {
    setSelectedProject({ label: "New Project", value: "new", data: "" });
    const newDate = new Date();
    axios.get(`agilesaas_project_master?ClientId=eq.` + id).then((res) => {
      // setProjectdetails(res.data);
      dispatch(
        HANDLE_ON_CHANGE({
          name: "projectdetails",
          value: res.data,
        })
      );
      setProjectOptions(res.data);
    });
    setdateerror("");
    setProjectNames("");
    // setseamlessopen(false);
    handleDateChange(new Date());
    handleDateChange2(newDate.setMonth(newDate.getMonth() + 6));
    setModules([
      {
        Name: "",
        Type: "Monolith",
        FullName: "",
      },
    ]);

  }
  const validateFormprojectc = () => {
    const newErrors = {};

    if (selectedProject?.value == "new" && projectnames.trim() == "") {
      newErrors.projectnames = "Enter the project name";
    } else if (
      moment(selectedDate2).diff(moment(selectedDate), "days") == 0 ||
      moment(selectedDate2).diff(moment(selectedDate), "days") < 0
    ) {
      setdateerror("Please check Dates-StartDate should be lower than EndDate");
      newErrors.selectedDate =
        "Please check Dates-StartDate should be lower than EndDate";
      // } else if (projectslength <= check) {
      //   toast.error(
      //     `You have exceeded the minimal plan please upgrade to higher plan Further... `,
      //     {
      //       transition: Slide,
      //       position: toast.POSITION.TOP_RIGHT,
      //       autoClose: 8000,
      //       draggable: true,
      //     }
      //   );
    }

    setError(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };
  return (
    <div className="h-100 w-100" style={{ fontFamily: "DM Sans" }}>
      {/* Header */}
      <div id="getstartheaderpart" className="d-flex align-items-center ml-3">
        <Image width={260} height={180} preview={false} src={agiler} />
        <div className="d-flex flex-column ml-2">
          <span style={{ fontSize: "2.2rem", fontWeight: 550 }}>
            Getting started
            <i className="mdi mdi-check-circle ml-1" style={{ color: "rgb(82, 80, 229)" }}></i>
          </span>
          <span>Follow these steps to setup your Kanban board.</span>
        </div>
      </div>

      {/* Progress and Steps */}
      <div id="middlepart" className="mt-4 p-2">
        <div className="shadow-sm" style={{ border: "1px solid rgb(238, 238, 238)", borderRadius: "8px", minHeight: "220px" }}>
          <div className="row no-gutters mt-1">
            <div className="col-9 mt-2">
              <span className="ml-4" style={{ fontSize: "20px", fontWeight: 500 }}>
                {currentStep === 1
                  ? "Create Project"
                  : currentStep === 2
                  ? "Invite Team"
                  : currentStep === 3
                  ? "Allocate Project"
                  : "Review & Submit"}
              </span>
            </div>
            <div className="col-3 px-3 pt-2 d-flex justify-content-end">
              <Progress
                percent={currentStep === 4 ? 100 : currentStep === 3 ? 75 : currentStep === 2 ? 50 : 25}
                strokeColor={"#15F5BA"}
                size={[110, 9]}
                showInfo={false}
                style={{ width: 110 }}
              />
              <span className="ml-1" style={{ fontSize: "12px" }}>
                {`Step ${currentStep} out of 4`}
              </span>
            </div>
          </div>

          {/* Step 1: Create Project */}
          {currentStep === 1 && (
            
  <div className="row mt-2 px-4">
        
    {/* Select Project */}
    <Col md={6}> {/* Ensure this column size matches the one for Project Name */}
      <FormControl fullWidth>
        <InputLabel>Select Project</InputLabel>
        <Select
          value={poptions.find((option) => option.value === selectedValue)}
          onChange={(selectedOption) => handleSelectProject(selectedOption)}
          options={poptions}
          FullWidth
          style={{ height: '56px' }}
        />
      </FormControl>
    </Col>

    {/* Project Name */}
    <Col md={6}> {/* Ensure this column size matches the one for Select Project */}
      <TextField
        label="Project Name"
        variant="outlined"
        style={{ height: '56px' }}
        fullWidth
        value={projectnames}
        onChange={(e) => handleProjectNameChange(e)}
        error={!!error.projectnames}
        helperText={error.projectnames}
      />
    </Col>

    {/* Rest of the form */}
    <div className="w-100 d-flex flex-column mt-4 ml-3">
      <Row className="align-items-center">
        <Col>
          <ProjectModules
            modules={modules}
            setModules={setModules}
            projectname={projectnames}
            projectid={selectedProject?.value}
          />
        </Col>
      </Row>
    </div>

    {/* Date Pickers */}
    <Col className="mt-3">
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          variant="inline"
          format="dd-MM-yyyy"
          margin="normal"
          label="Start Date"
          value={selectedDate}
          onChange={(date) => handleDateChange(date)}
          fullWidth
        />
      </MuiPickersUtilsProvider>
    </Col>
    <Col className="mt-3">
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          variant="inline"
          format="dd-MM-yyyy"
          margin="normal"
          label="End Date"
          value={selectedDate2}
          onChange={(date) => handleDateChange2(date)}
          fullWidth
        />
      </MuiPickersUtilsProvider>
      {projectRole == "SM" || projectRole == "KA" ?   <Col className="d-flex justify-content-end mt-3">
      <Button
        style={{
          fontSize: 14,
          padding: 9,
          width: 100,
          height: 40,
          borderRadius: 8,
          marginRight: 14,
          border: "2px solid #5250E5",
          backgroundColor: "#fff",
          color: "#5250E5",
          textAlign: "center",
          textTransform: "none",
        }}
        onClick={() => ProjectClose()}  // Replace with your cancel logic
      >
        Cancel
      </Button>
 <Button
        type="submit"
        onClick={(e) => handleProjectSubmit(e)}
        style={{
          fontSize: 14,
          padding: 9,
          width: 100,
          height: 40,
          borderRadius: 8,
          backgroundColor: "#5250E5",
          color: "#fff",
          border: "0px solid #5A88F1",
          textAlign: "center",
          textTransform: "none",
        }}
        // onClick={(e) => handleSubmit(e)}  // Replace with your submit logic
      >
        {checkSubmit ? (
                      <span
                        className="spinner-border"
                        role="status"
                        aria-hidden="true"
                        style={{
                          color: "#fff",
                          width: "1.5rem",
                          height: "1.5rem",
                        }}
                      ></span>
                    ) : (
                      "Submit"
                    )}
      </Button>

      
    </Col>
    : null}
    
    </Col>
  

    {/* Cancel and Submit buttons */}
 
  </div>

)}



          {/* Step 2: Add Team */}
          {currentStep === 2 && (
            <div className="row p-3">
              <div className="col-8">
                <Badge.Ribbon text="Add Team Members" style={{ top: -40 }}>
                  <Row className="mb-3 mt-0 ml-0 mr-0">
                    <label className="SprintlabelStyle">
                      First Name{" "}
                      <span className="text-muted" style={{ fontSize: "10px" }}>
                        (Optional)
                      </span>
                    </label>
                    <Input
                      className="SprintFormFields"
                      placeholder="Enter First Name"
                      value={firstname}
                      onChange={(e) => setfirstname(e.target.value)}
                      type="text"
                      invalid={errors.firstname !== undefined}
                    />
                    {errors.firstname && (
                      <FormFeedback>{errors.firstname}</FormFeedback>
                    )}
                  </Row>
                  
                  <Row className="mb-3 mt-0 ml-0 mr-0">
                    <label className="SprintlabelStyle">
                      Last Name{" "}
                      <span className="text-muted" style={{ fontSize: "10px" }}>
                        (Optional)
                      </span>
                    </label>
                    <Input
                      className="SprintFormFields"
                      placeholder="Enter Last Name"
                      value={secondname}
                      onChange={(e) => {
                        if (/^[A-Za-z]*$/.test(e.target.value)) {
                          setsecondname(e.target.value);
                        }
                      }}
                      type="text"
                      invalid={errors.secondname !== undefined}
                    />
                    {errors.secondname && (
                      <FormFeedback>{errors.secondname}</FormFeedback>
                    )}
                  </Row>

                  <Row className="mb-3 mt-0 ml-0 mr-0">
  <label className="SprintlabelStyle" style={{ display: 'block' }}>
    E-Mail <span className="text-danger">*</span>
    <span className="text-muted" style={{ display: 'block', fontSize: '10px' }}>
      (Click after entering to add multiple email ids)
    </span>
  </label>

  <div
    className={`email-input-container ${errors.email ? "invalid" : ""}`}
    style={{
      display: "flex",
      flexDirection: "column",
      maxHeight: "150px",
      overflowY: "auto",
      width: "100%", // Ensure it takes full width
    }}
  >
    <ReactMultiEmail
      className="SprintFormFields"
      style={{height:"60px"}}
      placeholder="Enter Email"
      emails={Email.map((email) => email.toLowerCase())}
      onChange={(newEmails) => setEmail(newEmails)}
      autoFocus={true}
      getLabel={(email, index, removeEmail) => (
        <div data-tag key={index}>
          <div data-tag-item>{email}</div>
          <span
            data-tag-handle
            onClick={() => removeEmail(index)}
          >
            ×
          </span>
        </div>
      )}
    />
    {errors.email && (
      <span className="text-danger">{errors.email}</span>
    )}
  </div>
</Row>


                  <Row className="mb-3 mt-0 ml-0 mr-0">
                    <label className="SprintlabelStyle">
                      Phone Number{" "}
                      <span className="text-muted" style={{ fontSize: "10px" }}>
                        (Optional)
                      </span>
                    </label>
                    <PhoneInput
                      inputStyle={{ backgroundColor: "#ffff", width: "100%" }}
                      containerStyle={{ backgroundColor: "#f3f3ff" }}
                      searchStyle={{ backgroundColor: "#f3f3ff" }}
                      buttonStyle={{
                        backgroundColor: "#f3f3ff",
                        height: "35px",
                      }}
                      dropdownStyle={{ backgroundColor: "#f3f3ff" }}
                      placeholder="Enter Mobile number"
                      value={phone}
                      onChange={setphone}
                      invalid={errors.phone !== undefined}
                    />
                    {errors.phone && <FormFeedback>{errors.phone}</FormFeedback>}
                  </Row>

                  {/* <Row className="mb-3 mt-0 ml-0 mr-0">
                    <Button
                      type="primary"
                      onClick={submitTeamMember} // Submit function for team members
                    >
                      Add Team Member
                    </Button>
                  </Row> */}
                     {projectRole == "SM" || projectRole == "KA" ?    <Col className="d-flex justify-content-end mt-3">
      <Button
        style={{
          fontSize: 14,
          padding: 9,
          width: 100,
          height: 40,
          borderRadius: 8,
          marginRight: 14,
          border: "2px solid #5250E5",
          backgroundColor: "#fff",
          color: "#5250E5",
          textAlign: "center",
          textTransform: "none",
        }}
        onClick={() => teamclose()}  // Replace with your cancel logic
      >
        Cancel
      </Button>
      <Button
        type="submit"
        onClick={(e) => submitTeamMember(e)}
        style={{
          fontSize: 14,
          padding: 9,
          width: 100,
          height: 40,
          borderRadius: 8,
          backgroundColor: "#5250E5",
          color: "#fff",
          border: "0px solid #5A88F1",
          textAlign: "center",
          textTransform: "none",
        }}
        // onClick={(e) => handleSubmit(e)}  // Replace with your submit logic
      >
        {checkSubmitteam ? (
                      <span
                        className="spinner-border"
                        role="status"
                        aria-hidden="true"
                        style={{
                          color: "#fff",
                          width: "1.5rem",
                          height: "1.5rem",
                        }}
                      ></span>
                    ) : (
                      "Submit"
                    )}
      </Button>
      
     
    </Col> : null}
                </Badge.Ribbon>
              </div>
              <div className="col-4 d-flex justify-content-center">
                <Image width={250} height={170} preview={false} src={coderepoimg} />
              </div>
            </div>
          )}

          {/* Step 3: Allocate Project */}
    {/* Step 3: Allocate Project */}
    {currentStep === 3 && (
  <div className="row p-3">
    <div className="col-8">
      <Badge.Ribbon text="Allocate Project" style={{ top: -40 }}>
        <Row className="mb-4 mt-2">
          <Col lg={6}>
            <label>Team Member</label>
            <Select
              name="TeamMemberId"
              isMulti={true}
              onChange={(e) => handleInputChange(e, "TeamMemberId")}
              options={employeeOption}
              error={Errors.TeamMemberId}
              helperText={Errors.TeamMemberId}
              value={
                Values.TeamMemberId
                  ? employeeOption?.filter((e) =>
                      Values?.TeamMemberId?.includes(e.value)
                    )
                  : []
              }
            />
            <FormHelperText style={{ color: "red" }}>
              {Errors.TeamMemberId}
            </FormHelperText>
          </Col>
          <Col lg={6}>
            <label>Project Name</label>
            <Select
              name="ProjectCode"
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              options={projectOptioeen}
              onChange={(e) => handleInputChange(e, "ProjectCode")}
              value={projectOptioeen?.filter(
                (option) => option.value == Values?.ProjectCode
              )}
              error={Errors.ProjectCode}
              helperText={Errors.ProjectCode}
            />
            <FormHelperText style={{ color: "red" }}>
              {Errors.ProjectCode}
            </FormHelperText>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col lg={6}>
            <label>Project Role</label>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              name="RoleGroupId"
              options={roleOption}
              onChange={(e) => {
                setValues({
                  ...Values,
                  ProjectRole: {
                    RoleName: e.label,
                    RoleGroupId: e.value,
                    RoleCode: e.RoleCode,
                  },
                });
              }}
              error={Errors.ProjectRole}
              helperText={Errors.ProjectRole}
              value={roleOption?.filter(
                (option) => option.value == Values?.ProjectRole?.RoleGroupId
              )}
              required
              native
            />
            <FormHelperText style={{ color: "red" }}>
              {Errors.ProjectRole}
            </FormHelperText>
          </Col>
          <Col lg={6}>
            <label>In Percent%</label>
            <TextField
              type="number"
              value={Values.AllocPercentage}
              onChange={(e) => handleInputChange(e, "AllocPercentage")}
              fullWidth
            />
            <FormHelperText style={{ color: "red" }}>
              {Errors.AllocPercentage}
            </FormHelperText>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col lg={6}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                label="Allocation Start Date"
                format="dd/MM/yyyy"
                value={Values.ProjectStartDate}
                onChange={(date) =>
                  DateInputChange(convertToPara("ProjectStartDate", date))
                }
                fullWidth
              />
            </MuiPickersUtilsProvider>
          </Col>
          <Col lg={6}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                label="Allocation End Date"
                format="dd/MM/yyyy"
                value={Values.ProjectEndDate}
                onChange={(date) =>
                  DateInputChange(convertToPara("ProjectStartDate", date))
                }
                fullWidth
              />
            </MuiPickersUtilsProvider>
          </Col>
        </Row>
        <Row className="mb-4">
        {projectRole == "SM" || projectRole == "KA" ?   
         <Col className="d-flex justify-content-end mt-3">
            <Button
              onClick={resetForm}
              style={{
                fontSize: 14,
                padding: 9,
                width: 100,
                height: 40,
                borderRadius: 8,
                marginRight: 14,
                border: "2px solid #5250E5",
                backgroundColor: "#fff",
                color: "#5250E5",
                textAlign: "center",
                textTransform: "none",
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              onClick={(e) => addAllocationHandler(e)}  // Add the allocation handler
              style={{
                fontSize: 14,
                padding: 9,
                width: 100,
                height: 40,
                borderRadius: 8,
                backgroundColor: "#5250E5",
                color: "#fff",
                border: "0px solid #5A88F1",
                textAlign: "center",
                textTransform: "none",
              }}
            >
              {checkSubmitteam ? (
                <span
                  className="spinner-border"
                  role="status"
                  aria-hidden="true"
                  style={{
                    color: "#fff",
                    width: "1.5rem",
                    height: "1.5rem",
                  }}
                ></span>
              ) : (
                "Submit"
              )}
            </Button>
          </Col> : null}
        </Row>
      </Badge.Ribbon>
    </div>
    <div className="col-4 d-flex justify-content-center">
      <Image width={250} height={170} preview={false} src={coderepoimg} />
    </div>
  </div>
)}


          {/* Step 4: Final Step */}
          {currentStep === 4 && (
  <div className="row p-1" style={{ display: 'flex', flexWrap: 'wrap' }}>
    <div className="col-lg-7 col-md-12" style={{ marginTop: '10px', paddingLeft: '15px' }}>
      <div className="d-flex flex-column mt-3 p-2">
        <label style={{ fontSize: '1rem', padding: '5px 0', lineHeight: '1.5' }}>
          <i className="mdi mdi-check-circle text-success"></i> Step 1: Client Onboarding & Admin Setup
        </label>
        <label style={{ fontSize: '1rem', padding: '5px 0', lineHeight: '1.5' }}>
          <i className="mdi mdi-check-circle text-success"></i> Step 2: Admin Invites Team Members
        </label>
        <label style={{ fontSize: '1rem', padding: '5px 0', lineHeight: '1.5' }}>
          <i className="mdi mdi-check-circle text-success"></i> Step 3: Team Members Activate Accounts
        </label>
        <label style={{ fontSize: '1rem', padding: '5px 0', lineHeight: '1.5' }}>
          <i className="mdi mdi-check-circle text-success"></i> Step 4: Assign Team to Project
        </label>
        <label style={{ fontSize: '1rem', padding: '5px 0', lineHeight: '1.5' }}>
          <i className="mdi mdi-check-circle text-success"></i> Step 5: Tasks Appear on Project Board
        </label>
        <label style={{ fontSize: '1rem', padding: '5px 0', lineHeight: '1.5' }}>
          <i className="mdi mdi-check-circle text-success"></i> Step 6: Groom Backlog with Team
        </label>
        <label style={{ fontSize: '1rem', padding: '5px 0', lineHeight: '1.5' }}>
          <i className="mdi mdi-check-circle text-success"></i> Step 7: Create & Prioritize Sprint
        </label>
        <label style={{ fontSize: '1rem', padding: '5px 0', lineHeight: '1.5' }}>
          <i className="mdi mdi-check-circle text-success"></i> Step 8: Team Updates Task Progress
        </label>
        <label style={{ fontSize: '1rem', padding: '5px 0', lineHeight: '1.5' }}>
          <i className="mdi mdi-check-circle text-success"></i> Step 9: Monitor Progress in Meetings
        </label>
      </div>
    </div>

    <div
      className="col-lg-5 col-md-12 d-flex justify-content-center align-items-center"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '10px',
        padding: '15px'
      }}
    >
      <Image width={680} height={590} preview={false} src={Agilepmsvg} />
    </div>
  </div>
)}


<div className="mt-1 d-flex justify-content-end p-2">
  {currentStep > 1 && (
    <Button
      className="mr-2"
      style={{
        fontSize: 14,
        padding: '8px 20px', 
        width: 80,
        height: 40,
      
        backgroundColor: '#ffffff', 
        color: '#5250E5', 
        border: '1px solid #5250E5',
        textAlign: 'center',
        textTransform: 'none',
        transition: 'all 0.3s ease',
      }}
      onClick={handlePrev}
     
    >
      Back
    </Button>
  )}
  {currentStep < 4 && (
    <Button
      type="primary"
      className="mr-2"
      style={{
        fontSize: 14,
        padding: '8px 20px', 
        width: 80,
        height: 40,
      
        backgroundColor: '#5250E5', 
        color: '#fff',
        border: '0px solid #5A88F1',
        textAlign: 'center',
        textTransform: 'none',
        transition: 'all 0.3s ease',
      }}
      onClick={handleNext}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = '#3e3cb8'; 
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = '#5250E5'; 
      }}
    >
      Next
    </Button>
  )}
  {currentStep === 4 && (
    <Button
      type="primary"
      style={{
        fontSize: 14,
        padding: '8px 20px',
        width: 120,
        height: 40,
        borderRadius: 8,
        backgroundColor: '#5250E5',
        color: '#fff',
        textAlign: 'center',
        textTransform: 'none',
      }}
      onClick={close}
    >
      Finish & Submit
    </Button>
  )}
</div>

        </div>
      </div>

      {/* Footer Help Section */}
      <div id="footerparthelp" className="mt-4">
        <div className="row">
          <div className="col-6">
            <div className="d-flex flex-column ml-4 p-1">
              <span style={{ fontSize: "20px", fontWeight: 500 }}>Need help with setting up?</span>
              <p style={{ fontSize: "0.85rem" }}>
                If you’re feeling stuck, please reach out to us via chat or schedule a call. Our team is ready to assist you.
              </p>
              <Button 
          variant="outlined" 
        
          style={{
            borderColor: '#5A3DFF', 
            color: '#5A3DFF', 
            textTransform: 'none',
            fontWeight: '500',
            fontSize: '14px',
            height:"40px",
            width:"100px"
          }}
        >
          Chat with us
        </Button>
            </div>
          </div>
          <div className="col-6 d-flex justify-content-end">
            <Image width={260} height={180} preview={false} src={footerimg} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Getstartedpage;
